export default __webpack_public_path__ + "static/media/right-arrow.265a50f5.svg";